import { FC } from 'react';

import { Typography } from '@mui/material';

import { Card } from 'src/components';

interface CreditNoteReasonProps {
    reasons: string;
}

export const CreditNoteReason: FC<CreditNoteReasonProps> = ({ reasons }) => {
    return (
        <Card color="#1d1d1b" flex={1} gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Credit Reason
            </Typography>
            <Typography color="#1D1D1B" fontSize="16px" fontWeight="400" lineHeight="24px">
                {reasons}
            </Typography>
        </Card>
    );
};
